import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService } from 'webcommon/core-ui';
import { FcLanguageListItemDto, FcModifyLanguageListItemDto } from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';

@Component({
  providers: [ApAlertService, FcListValidationService],
  selector: 'ap-fc-language-list-modal',
  templateUrl: './fc-language-list-modal.component.html',
})
  export class FcLanguageListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {
  public override baseId = 'fc-language-item';

  // List Item with default value
  public listItem: FcLanguageListItemDto = {
    Id: '',
    ExternalID: '',
    Code: '',
    Name: '',
    Notes: '',
    Inactive: false,
    UserDefined: true,
  };

  // Form Controls
  public externalIdControl: FormControl = new FormControl('');
  public codeControl: FormControl = new FormControl('');
  public nameControl: FormControl = new FormControl('');
  public notesControl: FormControl = new FormControl('');
  public inactiveControl: FormControl = new FormControl(false);
  public userDefinedControl: FormControl = new FormControl(true);

  // Form Group
  public form = new FormGroup({
    externalId: this.externalIdControl,
    code: this.codeControl,
    name: this.nameControl,
    notes: this.notesControl,
    inactive: this.inactiveControl,
    userDefined: this.userDefinedControl,
  });

  override ngOnInit() {
    super.ngOnInit();

    // Load List Item and set default validation rules
    this.loadListItem({
      ExternalID: {
        MaxLength: 25,
      },
      Name: {
        IsRequired: true,
        MaxLength: 50,
      },
      Code: {
        IsRequired: true,
        MaxLength: 50,
      },
      Notes: {
        MaxLength: 65535,
      },
    });
  }

  public setForm(): void {
    // External Id Control
    this.externalIdControl.setValidators(this.fcListValidation.getValidators('ExternalID'));
    this.externalIdControl.setValue(this.listItem.ExternalID);

    // Code Control
    const isCodeControlDisabled = !this.listItem.UserDefined;
    if (isCodeControlDisabled) {
      this.codeControl.disable();
    }
    this.codeControl.setValidators(this.fcListValidation.getValidators('Code'));
    this.codeControl.setValue(this.listItem.Code);

    // Name Control
    const isNameControlDisabled = !this.listItem.UserDefined;
    if (isNameControlDisabled) {
      this.nameControl.disable();
    }
    this.nameControl.setValidators(this.fcListValidation.getValidators('Name'));
    this.nameControl.setValue(this.listItem.Name);

    // Notes Control
    this.notesControl.setValidators(this.fcListValidation.getValidators('Notes'));
    this.notesControl.setValue(this.listItem.Notes);

    // Inactive Control
    this.inactiveControl.setValue(this.listItem.Inactive);

    // User Defined Control
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);

    this.validateForm();
  }

  public override save(): void {
    const values = this.form.getRawValue();
    const modifyItemDto: FcModifyLanguageListItemDto = {
      ExternalID: values.externalId,
      Code: values.code,
      Name: values.name,
      Inactive: values.inactive,
      Notes: values.notes,
      UserDefined: values.userDefined,
    };
    super.save<FcModifyLanguageListItemDto>(modifyItemDto);
  }
}
